import api from './axiosConfig';

type ID = number | string;

// ── inventarioService ─────────────────────────────────────────
export const inventarioService = {
  getAlmacenes:  (empresaId: ID, sucursalId?: ID) =>
    api.get('/pos/inventario/almacenes', { params: { empresaId, sucursalId } }).then(r => r.data),
  createAlmacen: (data: any) => api.post('/pos/inventario/almacenes', data).then(r => r.data),
  getStock:      (almacenId?: ID, productoId?: ID, soloConStock = false) =>
    api.get('/pos/inventario/stock', { params: { almacenId, productoId, soloConStock } }).then(r => r.data),
  ajustarStock:  (data: any) => api.post('/pos/inventario/ajuste', data).then(r => r.data),
  getMovimientos:(params?: any) =>
    api.get('/pos/inventario/movimientos', { params }).then(r => r.data),
};

// ── stockService ──────────────────────────────────────────────
export const stockService = {
  getAll:    (filtros?: any) =>
    api.get('/pos/inventario/stock', { params: filtros }).then(r => r.data),
  getStockBajo: (empresaId: ID = 0) =>
    api.get(`/pos/reportes/stock-critico/${empresaId}`).then(r => r.data),
  // ubicacion puede ser string o un objeto {pasillo, rack, nivel}
  actualizarUbicacion: (id: ID, ubicacion: string | { pasillo?: string; rack?: string; nivel?: string }) => {
    const ubicStr = typeof ubicacion === 'string'
      ? ubicacion
      : [ubicacion.pasillo, ubicacion.rack, ubicacion.nivel].filter(Boolean).join('-');
    return api.patch(`/pos/inventario/stock/${id}/ubicacion`, { ubicacion: ubicStr }).then(r => r.data);
  },
};

// ── almacenesService ──────────────────────────────────────────
export const almacenesService = {
  getAll:     (params?: any) =>
    api.get('/pos/inventario/almacenes', { params }).then(r => r.data),
  getById:    (id: ID) =>
    api.get('/pos/inventario/almacenes', { params: {} })
      .then(r => (r.data?.data ?? r.data ?? []).find((a: any) => a.almacenId === Number(id))),
  create:     (data: any) => api.post('/pos/inventario/almacenes', data).then(r => r.data),
  update:     (id: ID, data: any) =>
    api.put(`/pos/inventario/almacenes/${id}`, data).then(r => r.data),
  getResumen: (almacenId: ID) =>
    api.get('/pos/inventario/stock', { params: { almacenId } }).then(r => r.data),
};

// ── movimientosService ────────────────────────────────────────
export const movimientosService = {
  getAll:    (filtros?: any) =>
    api.get('/pos/inventario/movimientos', { params: filtros }).then(r => r.data),
  create:    (data: any) =>
    api.post('/pos/inventario/ajuste', data).then(r => r.data),
  getKardex: (productoId: ID, filtros?: any) =>
    api.get('/pos/inventario/movimientos', { params: { productoId, ...filtros } }).then(r => r.data),
};

// ── transferenciasService (sin endpoint en backend aún) ───────
export const transferenciasService = {
  getAll:   (_filtros?: any): Promise<any>       => Promise.resolve({ data: [], totalCount: 0 }),
  create:   (_data: any): Promise<any>           => Promise.resolve({}),
  enviar:   (_id: ID): Promise<void>             => Promise.resolve(),
  recibir:  (_id: ID, _items: any[]): Promise<void> => Promise.resolve(),
  cancelar: (_id: ID, _motivo: string): Promise<void> => Promise.resolve(),
};

// ── conteosService (sin endpoint en backend aún) ──────────────
export const conteosService = {
  getAll:    (_filtros?: any): Promise<any>       => Promise.resolve({ data: [], totalCount: 0 }),
  create:    (_data: any): Promise<any>           => Promise.resolve({}),
  iniciar:   (_id: ID): Promise<void>             => Promise.resolve(),
  finalizar: (_id: ID): Promise<void>             => Promise.resolve(),
  cancelar:  (_id: ID, _motivo: string): Promise<void> => Promise.resolve(),
};

// ── lotesService ──────────────────────────────────────────────
export const lotesService = {
  getAll:            (filtros?: any) =>
    api.get('/pos/inventario/stock', { params: filtros }).then(r => r.data),
  getById:           (id: ID) =>
    api.get('/pos/inventario/stock', { params: { loteId: id } }).then(r => r.data),
  getProximosAVencer:(dias: number) =>
    api.get('/pos/inventario/stock', { params: { diasVencimiento: dias } }).then(r => r.data),
  create:            (data: any) =>
    api.post('/pos/inventario/ajuste', data).then(r => r.data),
  cambiarEstado:     (_id: ID, _estado: string): Promise<void> => Promise.resolve(),
};
